import { AdvancedFilterType, SavedSearch } from 'talent_matching/types';
import AdvancedFilter from 'talent_matching/components/filters/advanced_filter';

function safeJsonParse(value: string): unknown {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function toSavedSearchQueryString(params: SavedSearch): string {
  const searchParams = new URLSearchParams();

  for (const paramKey in params) {
    if (params.hasOwnProperty(paramKey)) {
      const key = paramKey as keyof SavedSearch;
      const value = params[key];
      if (Array.isArray(value)) {
        value.forEach((element) => {
          if (typeof element === 'object') {
            const serializedElement = JSON.stringify(element);
            searchParams.append(`${key}[]`, serializedElement);
          } else {
            searchParams.append(`${key}[]`, element);
          }
        });
      } else if (value && typeof value === 'object') {
        Object.entries(value).forEach(([subKey, subValue]) => {
          searchParams.append(`${key}[${subKey}]`, subValue as string);
        });
      } else {
        searchParams.append(key as string, value as string);
      }
    }
  }

  return searchParams.toString();
}

export function extractFormFieldsFromSavedSearch(
  params: SavedSearch
): SavedSearch {
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const typedKey = key as keyof SavedSearch;
      const paramsValue = params[typedKey];
      if (Array.isArray(paramsValue)) {
        params[typedKey] = paramsValue.map((value) => {
          const isAdvancedFiltersKey =
            typedKey === 'advancedFilters' ||
            typedKey === 'questionFilters' ||
            typedKey === 'educationFilters';

          if (typeof value === 'string') {
            const parsed = safeJsonParse(value);

            if (isAdvancedFiltersKey) {
              return isRecord(parsed)
                ? new AdvancedFilter(parsed as AdvancedFilterType)
                : new AdvancedFilter();
            }

            if (typeof parsed === 'string') {
              return parsed;
            }

            if (isRecord(parsed)) {
              return parsed;
            }

            return value;
          }

          if (isAdvancedFiltersKey && typeof value === 'object') {
            return value instanceof AdvancedFilter
              ? value
              : new AdvancedFilter(value as AdvancedFilterType);
          }

          return value;
        });
      } else if (typeof paramsValue === 'object' && paramsValue !== null) {
        params[typedKey] = paramsValue;
      } else if (paramsValue === 'null') {
        params[typedKey] = null;
      } else if (paramsValue === 'true') {
        params[typedKey] = true;
      } else if (paramsValue === 'false') {
        params[typedKey] = false;
      } else {
        params[typedKey] = params[typedKey];
      }
    }
  }

  return params;
}
